export default __webpack_public_path__ + "static/media/user_dashboard_8.f0cf969f.jpg";